import { inject, Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { ROUTES } from '@core/constants';
import { ILookUp, IResponseHttp } from '@core/models';

@Injectable({
  providedIn: 'root',
})
export class LookupService {
  private readonly apiService = inject(ApiService);

  async getDocumentType() {
    const result = await this.apiService.get<IResponseHttp>(
      ROUTES.LOOKUP_DOCUMENT_TYPE_OPTIONS,
    );
    const data = result.payload as ILookUp[];
    return data.map((item) => ({ ...item, code: item.id }));
  }

  async getBrandsCars() {
    const result = await this.apiService.get<IResponseHttp>(ROUTES.LOOKUP_BRAND_CARS);
    const data = result.payload as ILookUp[];
    return data.map((item) => ({
      id: item.id,
      name: item.label,
      brandId: item.parentId!,
    }));
  }

  async getModelsCars(brandId?: string) {
    const result = await this.apiService.get<IResponseHttp>(
      `${ROUTES.LOOKUP_CARS_MODELS_BY_BRAND(brandId)}`,
    );
    const data = result.payload as ILookUp[];
    return data.map((item) => ({
      id: item.id,
      name: item.label,
      brandId: item.parentId!,
    }));
  }

  async getYearsAndEnginesCC() {
    const result = await this.apiService.get<IResponseHttp>(ROUTES.LOOKUP_CARS_YEARS_AND_ENGINES_CC);
    const data = result.payload;
    return data;
  }
}
